module.exports = __webpack_public_path__ + "img/border-right.5cde73c3.svg";